import { makeStyles } from "@material-ui/core/styles";
import tinycolor from "tinycolor2";
import { colorConstant } from "../../style/Color.constant";

export default makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "#000",
    opacity: 0.5 + "!important",
  },
  modalBody: {},
  borerRight: {
    borderRight: "1px solid",
  },
  modalTitle: {
    background: "#e4fffe",
    padding: ".3em 0em .3em 1em",
    fontSize: "1.3em",
    borderTopLeftRadius: ".4em",
    borderTopRightRadius: ".4em",
    height: "50px",
  },
  modalContent: {
    textAlign: "left !important",
    padding: "1em",
  },
  modalFooter: {
    textAlign: "right",
    padding: "1em",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  paper800: {
    position: "absolute",
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  paper500: {
    position: "absolute",
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  paper700: {
    position: "absolute",
    width: 700,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #dbdbdb",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0, 0, 1),
    borderRadius: ".4em",
  },
  deActivateButton: {
    textTransform: "capitalize",
    backgroundColor: "#014e8c",
    border: "1px solid  #014e8c",
    color: "#fff",
  },
  resetButton: {
    background: "#014e8c",
    color: "#fff",
    textTransform: "capitalize",
  },
  width100: {
    width: "100%",
  },
  cancelButton: {
    marginRight: "1em",
    color: "#014e8c",
    textTransform: "capitalize",
    border: "1px solid  #014e8c",
  },
  bold: {
    fontWeight: "bold",
    color: "#212121",
    textTransform: "capitalize",
  },
  snackbarRoot: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  layoutContainer: {
    height: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(2),
    border: "1px dashed",
    borderColor: theme.palette.primary.main,
    position: "relative",
  },
  layoutText: {
    color: tinycolor(theme.palette.background.light).darken().toHexString(),
  },
  layoutButtonsRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  layoutButton: {
    backgroundColor: theme.palette.background.light,
    width: 125,
    height: 50,
    outline: "none",
    border: "none",
  },
  layoutButtonActive: {
    backgroundColor: tinycolor(theme.palette.background.light)
      .darken()
      .toHexString(),
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: theme.spacing(2),
  },
  notificationCallButton: {
    color: "white",
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  codeContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
  },
  codeComponent: {
    flexGrow: 1,
  },
  notificationItem: {
    marginTop: theme.spacing(2),
  },
  notificationCloseButton: {
    position: "absolute",
    right: theme.spacing(2),
  },
  toastsContainer: {
    width: 400,
    marginTop: theme.spacing(6),
    right: 0,
  },
  progress: {
    visibility: "hidden",
  },
  formFields: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#212121",
  },
  notification: {
    display: "flex",
    alignItems: "center",
    background: "transparent",
    boxShadow: "none",
    overflow: "visible",
  },
  notificationComponent: {
    paddingRight: theme.spacing(4),
  },
  errortoaster: {
    backgroundColor: colorConstant.errorToaster,
    borderRadius: 40,
    textAlign: "center",
    fontSize: 12,
  },
  successtoaster: {
    backgroundColor: colorConstant.successToaster,
    borderRadius: 40,
    textAlign: "center",
    fontSize: 12,
  },
  infotoaster: {
    backgroundColor: colorConstant.infoToaster,
    borderRadius: 40,
    fontSize: 12,
    textAlign: "center",
  },
  inputfile: {
    width: "0.1px",
    height: "0.1px",
    opacity: 0,
    overflow: "hidden",
    position: "absolute",
    zIndex: -1,
  },
  uploadLabel: {
    width: "100%",
    height: "100%",
    border: "1px dashed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  suspensePrinting: {
    float: "left",
  },
  addSuspense: {
    marginTop: "1em",
  },
  noticeTable: {
    //   boxShadow:'0 2px 8px #f0f1f2',
    backgroundColor: "#fafafa",
    height: "34px",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
  },
  subHeading: {
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "0.5em",
  },
  autoDropdown: {
    fontSize: "12px !important",
  },
}));
